import { ButtonPropsType } from '@insurancemenu/imenu-components-lib/dist/types';
import React from 'react';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';

interface Props extends Omit<ButtonPropsType, 'children'> {
  title: string;
  onClick: () => void;
  opened: boolean;
}

export const MainActionButton: React.FC<Props> = (props) => {
  const { title, onClick, opened, ...rest } = props;
  return (
    <Button
      onClick={onClick}
      color="custom"
      customColor={colors.green[600]}
      size="large"
      width="25rem"
      rightIconProp={opened ? <ChevronUp /> : <ChevronDown />}
      {...rest}
    >
      {title}
    </Button>
  );
};
